export type RoundsRoundResult = {
  pointsAtStart: number;
  pointsDelta: number;
  rosterId: string;
};

export const getRoundsModeRoundResultDisplayScore = (
  result: RoundsRoundResult
) => {
  return (result.pointsAtStart + result.pointsDelta).toString();
};
